<template>
  <div class="about">
    <h1>
      {{$t('about.PAGE_HEADING')}}
    </h1>

    <div class="page-body" v-html="$t('about.PAGE_BODY')">
    </div>
    <div class="accolades">
      <div v-for="accolade in accolades" class="accolade">
        <div v-if="accolade=='HOSTING_ADVICE'" style="cursor:pointer" onclick="window.open('https://www.hostingadvice.com/how-to/free-web-hosting/#bravenet','_blank');">
          <p>{{$t(`about.${accolade}_SERVICE_QUOTE`)}}</p>
          <img :src="require(`assets/img/about/${accolade.toLowerCase()}.png`)"/>
        </div>
        <div v-else>
           <p>{{$t(`about.${accolade}_SERVICE_QUOTE`)}}</p>
          <img :src="require(`assets/img/about/${accolade.toLowerCase()}.png`)"/>
        </div>  
      </div>
    </div>
    <div class="divider" />
    <h2>{{$t('about.EMPLOYEE_GARDEN_HEADING')}}</h2>
    <div class="employees">
      <div class="employee" v-for="employee in employees">
        <img :src="employee.portrait"/>
        <h3>{{$t(`about.${employee.messageId}_HEADING`)}}</h3>
        <div>{{$t(`about.${employee.messageId}_TITLE`)}},</div>
        <div>{{$t(`about.${employee.messageId}_FUN_TITLE`)}}</div>
        <div class="fun-quote">{{$t(`about.${employee.messageId}_FUN_QUOTE`)}}</div>

      </div>
    </div>
    <hr />
  </div>
</template>

<script>

import employees from 'assets/data/about/employees.json'
import style from 'styles/about.scss'

export default {
  name: 'about',
  data () {
    return {
      employees: employees.map(employee => {
        return {
          portrait: require(`assets/img/about/${employee}.jpg`),
          messageId: employee.toUpperCase()
        }
      }),
      accolades: ['TUCOWS', 'INTERNET_MAGAZINE', 'HOSTING_ADVICE', 'HTML_GOODIES']
    }
  }
}
</script>




// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/about.vue